import React from 'react';

const TemplateFooter2 = ({ branding }) => {
  const logoUrl = 'https://trawtelcdn.s3.eu-north-1.amazonaws.com/smarttravelcrm/uploads/companies/efd32bd2-6639-42ed-9b1a-7e262da1be07/logos/efd32bd2-6639-42ed-9b1a-7e262da1be07.png';
  const navLinks = ['Home', 'About', 'Tours', 'Privacy Policy', 'Contact'];

  const styles = {
    footer: {
      backgroundColor: '#f8f9fa', // Very light grey
      padding: '3rem 2rem',
      fontFamily: 'Helvetica, sans-serif',
      textAlign: 'center'
    },
    logo: {
      height: '40px',
      marginBottom: '1.5rem',
    },
    nav: {
      display: 'flex',
      justifyContent: 'center',
      gap: '2rem',
      marginBottom: '1.5rem',
    },
    navLink: {
      textDecoration: 'none',
      color: '#6c757d', // Muted text color
      fontWeight: '500'
    },
    copyright: {
      color: '#adb5bd', // Even lighter text color
      fontSize: '0.9rem'
    }
  };

  return (
    <footer style={styles.footer}>
      <img src={logoUrl} alt="Company Logo" style={styles.logo} />
      <nav style={styles.nav}>
        {navLinks.map(link => (
          <a key={link} style={styles.navLink}>{link}</a>
        ))}
      </nav>
      <p style={styles.copyright}>&copy; {new Date().getFullYear()} Zotari. All rights reserved.</p>
    </footer>
  );
};

export default TemplateFooter2;